import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import SelectionModal from '../SelectionModal';
// icons
import Pause2Icon from 'zignal-landscape/lib/Icon/Pause2Icon';
import Play1Icon from 'zignal-landscape/lib/Icon/Play1Icon';
import MfeDashAllIcon from 'zignal-landscape/lib/Icon/MfeDashAllIcon';

export const getFilterData = (model) => {
  const { active } = model;
  const filterTypes = [];
  let icon = Play1Icon;
  if (active) {
    filterTypes.push('Active');
  } else {
    icon = Pause2Icon;
    filterTypes.push('Paused');
  }
  return { filterTypes, icon };
};

const DEFAULT_PARAMS = [];

const SimpleModal = ({
  title,
  getCollection,
  modelId,
  baseUrl,
  defaultUrl,
  modelType,
  onClose = noop,
  navigateBackBone = noop,
  newItem = noop,
  params = DEFAULT_PARAMS
}) => {
  const [refreshCollection, setRefreshCollection] = useState(false);
  const [isTakingAction, setIsTakingAction] = useState(false);

  const collection = getCollection();
  const models = collection ? collection.toJSON() : [];
  const items = models.map((model) => {
    const { id, name: label } = model;
    const active = modelId && modelId === id;
    const href = `${baseUrl}${id}/`;
    const filterData = getFilterData(model);
    return { id, active, label, href, isOwner: true, model, ...filterData };
  });

  const onClickItem = useCallback((e) => {
    onClose();
    navigateBackBone(e);
  });
  const onAddItem = useCallback((e) => {
    onClose();
    newItem(e);
  });
  const onDeleteItem = useCallback((e, {id, active}) => {
    if (isTakingAction) {
      return;
    }
    setIsTakingAction(true);
    if (confirm(`Are you sure you want to delete this ${modelType}?`)) {
      const model = collection.find((model) => model.get('id') === id);
      model.destroy({
        wait: true,
        success: () => {
          if (active) {
            navigateBackBone(e, defaultUrl);
          }
          setRefreshCollection(!refreshCollection);
          setIsTakingAction(false);
        },
        failure: () => {
          setRefreshCollection(!refreshCollection);
          setIsTakingAction(false);
        }
      });
    } else {
      setIsTakingAction(false);
    }
  }, [collection, navigateBackBone, isTakingAction, setRefreshCollection, setIsTakingAction]);

  // only for alerts, leave undefined for reading lists
  const filters = modelType === 'alert' ? [
    {label: 'Active', icon: Play1Icon },
    {label: 'Paused', icon: Pause2Icon },
    {label: 'All', icon: MfeDashAllIcon },
  ] : undefined;

  return (<SelectionModal
    title={title}
    items={items}
    onClose={onClose}
    onClickItem={onClickItem}
    onAddItem={onAddItem}
    onDeleteItem={onDeleteItem}
    filters={filters}
  />);
};

SimpleModal.propTypes = {
  params: PropTypes.array,
  onClose: PropTypes.func,
  navigateBackBone: PropTypes.func,
  newItem: PropTypes.func
};

export default SimpleModal;
